<template>
  <div class="container">
    <h1>{{ $t('home.lightingSolution.title') }}</h1>

    <div class="section">
      <h2>{{ $t('home.lightingSolution.structureTitle') }}</h2>
      <div class="device-tags">
        <span
          v-for="(device, idx) in $t('home.lightingSolution.devices')"
          :key="idx"
          class="device-tag"
        >
          {{ device }}
        </span>
      </div>
    </div>

    <div class="section">
      <h2>{{ $t('home.lightingSolution.sceneTitle') }}</h2>
      <div
        class="scenario"
        v-for="(sc, sIdx) in $t('home.lightingSolution.scenarios')"
        :key="sIdx"
      >
        <div class="scenario-title">{{ sc.title }}</div>
        <div class="scenario-flow">{{ sc.flow }}</div>
      </div>
    </div>

    <div class="section">
      <h2>{{ $t('home.lightingSolution.advantagesTitle') }}</h2>
      <ul>
        <li v-for="(adv, aIdx) in $t('home.lightingSolution.advantages')" :key="aIdx">
          {{ adv }}
        </li>
      </ul>
    </div>

    <div class="section">
      <h2>{{ $t('home.lightingSolution.tipsTitle') }}</h2>
      <ul>
        <li v-for="(tip, tIdx) in $t('home.lightingSolution.tips')" :key="tIdx">
          {{ tip }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LightingControlSolution'
}
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
h1, h2, h3 {
  color: #2c3e50;
  margin-bottom: 12px;
}
.device-tags {
  margin: 12px 0;
}
.device-tag {
  display: inline-block;
  padding: 6px 12px;
  font-size: 0.9rem;
  color: #fff;
  background: #409eff;
  border-radius: 4px;
  margin-right: 8px;
  margin-bottom: 6px;
}
.section {
  margin-bottom: 24px;
}
.scenario-title {
  font-weight: bold;
  margin-bottom: 6px;
}
.scenario-flow {
  padding: 10px 12px;
  background: #eaf4ff;
  border-left: 4px solid #409eff;
  border-radius: 4px;
}
</style>
